import {Messages} from '../../constants';

const validation = {
  chave: {
    presence: {
      message: Messages.RequiredChaveValidationMessage,
      allowEmpty: false,
    },
  },
  cpf: {
    presence: {
      message: Messages.RequiredCpfValidationMessage,
      allowEmpty: false,
    },
  },
};

export default validation;
